<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import RevisionPagination from "../../../components/standard/revisionAnual/RevisionPagination.vue";
import evaluacionIdentificacionAPI from "../../../services/standards/evaluacionIdentificacion/evaluacionIdentificacionAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "2.3.1 Evaluación de estándares mínimos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    RevisionPagination
  },
  data() {
    return {
      title: "2.3.1 Evaluación de estándares mínimos",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Evaluación e identificación de Prioridades",
          active: true,
        },
      ],

      years: [],
      lista: [],
      file: null,
      loading: true,
      guardando: false,

      list: [
        {
          id: 1,
          name: "ARL"
        },
        {
          id: 2,
          name: "Ministerio de Trabajo"
        },
      ],

      item: null,
      itemStatus: null,
      itemData: null,
      evaluacionIdentificacion: {
        file: "Datos",
        entity: null,
        year: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(14)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    rangeYear() {
      const max = 2040
      const min = 2019
      for (let i = min; i <= max; i++) {
        this.years.push(i)
      }
      return this.years
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 3)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status ? response.status : null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getList() {
      evaluacionIdentificacionAPI.getShow(this.$route.params.id)
        .then((response) => {
          this.loading = false
          this.evaluacionIdentificacion = {
            file: response.file,
            entity: response.entity,
            year: response.year,
            companies_id: response.companies_id,
          };
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.evaluacionIdentificacion.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/2.3.1/${this.$route.params.id}/${name}`;
        } else {
          url = `sst-prod/${this.company.nit}/2.3.1/${this.$route.params.id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.evaluacionIdentificacion.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      this.guardando = true
      this.loading = true
      let document = await this.uploadDocument();
      if (document) {
        evaluacionIdentificacionAPI.update(this.$route.params.id, {
          file: this.evaluacionIdentificacion.file,
          entity: this.evaluacionIdentificacion.entity,
          year: this.evaluacionIdentificacion.year,
          companies_id: this.evaluacionIdentificacion.companies_id,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 14,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Informacion actualizada con éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  this.$router.go(-1);
                }, 1000)
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡No se ha podido registrar!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 1000)
      }
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItems()
    this.getList();
    this.getItemData();
    this.rangeYear();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Anualmente la alta dirección deberá revisar el Sistema de Gestión de SST evaluando su desempeño,
                      cumplimiento de plan de trabajo, política y objetivos, basado en lo dispuesto en el Decreto 1072
                      de 2015.

                      El aplicativo permite descargar el formato de acta que servirá como referente para realizar la
                      revisión y documentar los temas tratados.
                    </p>
                  </CheckModal>
                </div>

              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group id="cycle" label-for="cycle" class="col-md-6 px-2" label="Seleccionar entidad">
                    <select required :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="evaluacionIdentificacion.entity">
                      <b-form-select-option v-for="item in list" :key="item.id" :value="item.name">
                        {{ item.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group id="cycle" label-for="cycle" class="col-md-6 px-2" label="Seleccionar año">
                    <select required :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="evaluacionIdentificacion.year">
                      <b-form-select-option v-for="item in years" :value="item">
                        {{ item }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="evaluacionIdentificacion.file ? getFile(evaluacionIdentificacion.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="guardando" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>